import { IconVideoClose } from "@/components/icon/simrnoff"
import { IconVideoPlay } from "@/components/icon/tanqueray"
import { DdpImage } from "@/components/shared/DdpImage"
import { DdpVideo } from "@/components/shared/DdpVideo"
import { FullVideo } from "@/components/shared/FullVideo"
import { TDdpMedia } from "@/shared/types"
import { useRef, useState } from "react"

export function HeroSection(props: Array<{
    heroImageLogo: Array<TDdpMedia>
    heroVideo: Array<TDdpMedia>
    previewVideo: Array<TDdpMedia>
    textAfterPlayButton: string
}>) {
    const { heroVideo, previewVideo, textAfterPlayButton, heroImageLogo } = props[0];
    const [showFullVideo, setShowFullVideo] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    return (
        <div className="landing-hero-section">
            <DdpVideo ref={videoRef} className="hero-video" video={previewVideo[0]} autoPlay muted loop>
                <div className="hero-video-content">
                    <DdpImage className="hero-logo" image={heroImageLogo} />
                    <div className="cta-play-wrapper" onClick={() => {
                        setShowFullVideo(true);
                        videoRef.current?.pause()
                    }}>
                        <IconVideoPlay />
                        <span className="cta-text">{textAfterPlayButton}</span>
                    </div>
                </div>
            </DdpVideo>
            {
                showFullVideo && <FullVideo video={heroVideo[0]} onLoadedMetadata={() => {
                    videoRef.current?.pause()
                }}  >
                    <div className="close-wrapper" onClick={() => {
                        setShowFullVideo(false);
                        videoRef.current?.play()
                    }}>
                        <span className="close-text">{textAfterPlayButton}</span>
                        <IconVideoClose />
                    </div>
                </FullVideo>
            }

        </div>
    );
}